module.exports = __webpack_public_path__ + "img/elite_logo.25d2526a.png";